<template>
  <!--  <nav>-->
  <!--    <router-link to="/">Home</router-link> |-->
  <!--    <router-link to="/about">About</router-link>-->
  <!--  </nav>-->
  <router-view />
</template>

<script lang="ts">
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
export default {
  name: 'App',
  setup () {
    const { locale } = useI18n()
    // watch(() => locale.value, (newLocale) => {
    //   document.title = newLocale === 'en' ? 'Brand Verification' : '品牌认证'
    // })
    // 监听语言变化并更新HTML lang属性
    watch(locale, (newLocale) => {
      document.documentElement.lang = newLocale
    })
  }
}

</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
